const focusDirective = {
	mounted(el: HTMLElement) {
		el.focus()
	},
}

export default focusDirective
